module.exports = __webpack_public_path__ + "static/img/home-img-4.1b5c7f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home-img-4.jpg
// module id = xyL5
// module chunks = 0